var t={baseUrl:function(t){return"".concat(null!=t?t:"https://cdn6.agoda.net","/images/kite-js/logo/")}};export{t as default};
